/**
 * Public Health & Medical Services department helpers (off days + referral attendance).
 */

export function isPublicHealthMedicalServicesName(name) {
  const n = String(name || "")
    .toUpperCase()
    .replace(/\s+/g, " ")
    .trim();
  if (!n) return false;
  // Exact / common variants for Homa Bay
  if (n.includes("PUBLIC HEALTH") && (n.includes("MEDICAL") || n.includes("SERVICES"))) {
    return true;
  }
  if (n === "PUBLIC HEALTH" || n.startsWith("PUBLIC HEALTH &")) {
    return true;
  }
  if (n.includes("HEALTH") && n.includes("MEDICAL SERVICES")) {
    return true;
  }
  return false;
}

export function currentUserIsPublicHealthMedicalServices() {
  try {
    const emp = JSON.parse(sessionStorage.getItem("employeeInfo") || sessionStorage.getItem("employee") || "{}") || {};
    const user = JSON.parse(sessionStorage.getItem("userInfo") || "{}") || {};
    const name =
      emp.departmentName ||
      emp.department ||
      user.departmentName ||
      user.department ||
      "";
    return isPublicHealthMedicalServicesName(name);
  } catch (_) {
    return false;
  }
}
